export default __webpack_public_path__ + "static/media/arrow_right_white.e6e6a3f4.svg";